<template>
  <div ref="iconBubblesWrap" class="iconBubbles-wrap" v-show="show">
    <div class="frame">
      {{text}}
      <span class="triangle"></span>
    </div>
  </div>


</template>
<script>
  export default {
    props: {
      // targetPos: {
      //   type: Object,
      //   default: {}
      // },
      // show: {
      //   type: Boolean,
      //   default: false,
      // },
    },
    data() {
      return {
        text: '',
        targetPos: {},
        show: false,
        timer: null
      }
    },
    methods: {
      showBubbles(text, pos) {
        if (this.timer) clearTimeout(this.timer)
        this.show = false;
        this.text = text;
        // this.$refs.iconBubblesWrap.style.right = ((window.screen.width - pos.left) - pos.width / 2) / 37.5 + "rem"
        // this.$refs.iconBubblesWrap.style.top = (pos.top - 50) / 37.5 + "rem"
        this.show = true;
        console.log(window.screen.width, ((window.screen.width - pos.left) - pos.width / 2) / 37.5 + "rem", (pos.top -
          50) / 37.5 + "rem")
        this.timer = setTimeout(() => {
          // this.show = false;
        }, 1500)
      }
    },
    mounted() {

    }
  }

</script>
<style scoped lang="less">
  .iconBubbles-wrap {
    position: absolute;
    z-index: 999;
    left: 0;
    top: 0;
    display: inline-block;
    text-align: right;

    .frame {
      position: relative;
      display: inline-block;
      min-width: 10px;
      height: 32px;
      line-height: 32px;
      border-radius: 17px;
      padding: 0 10px;
      background-color: rgba(107, 107, 107, 1);
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      z-index: 2;

      &::after {
        content: '';
        width: 15px;
        height: 15px;
        display: inline-block;
        position: absolute;
        bottom: -2px;
        right: 4px;
        background-color: rgba(107, 107, 107, 1);
        transform: rotate(19deg);
        -ms-transform: rotate(19deg);
        /* IE 9 */
        -moz-transform: rotate(19deg);
        /* Firefox */
        -webkit-transform: rotate(19deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(19deg);
        /* Opera */
        clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%, 0% 100%, 0 100%, 0 100%, 0% 15px, 15px 0);
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/iconBubbles.vue